<template>
  <div class="popWrap">
    <div class="popup">
      <div class="popContain">
        <div class="popCont full hasBtn" tabindex="-1" role="dialog">
          <div class="popHead">
            <h1 class="titH1">나의 문의 등록</h1>
          </div>
          <div class="popBody full" style="overflow:auto;">
            <div class="popInner">
              <!-- 본문 (s) -->
              <section>
                <div class="formArea">
                  <span class="label">
                    유형 선택
                    <span class="required"><span class="blind">필수</span></span>
                    <span class="mg0 txtXS pointC1 fr" aria-hidden="true">필수*</span>
                  </span>
                  <div class="setHalf">
                    <div class="sltWrap">
                      <select class="ipt notDel uiAct" id="agency_4" title="대분류 선택" v-model="mainCode" @change="selectMainCode">
                        <option value="">대분류</option>
                        <option
                          v-for="(mainCodeValue, mainCodeIndex) in mainCodeList"
                          :key="mainCodeIndex"
                          :value="mainCodeValue.code"
                          v-text="mainCodeValue.codeName"
                        ></option>
                      </select>
                    </div>
                    <div class="sltWrap">
                      <select class="ipt notDel uiAct" id="agency_4" title="중분류 선택" v-model="subCode">
                        <option value="">중분류</option>
                        <option
                          v-for="(subCodeValue, subCodeValueIndex) in subCodeList"
                          :key="subCodeValueIndex"
                          :value="subCodeValue.code"
                          v-text="subCodeValue.codeName"
                        ></option>
                      </select>
                    </div>
                  </div>

                  <span class="label">상품 선택</span>
                  <div class="prdSelArea">
                    <div class="btnArea nowrap">
                      <button type="button" class="btn_g m" @click="openSearchPop">전체상품</button>
                      <button type="button" class="btn_g m" @click="openOrderPop">나의 주문상품</button>
                    </div>

                    <ul class="prdList line" id="prd_search_rlt">
                      <li v-if="product != null">
                        <div class="block">
                          <div class="prdItem xs">
                            <div class="imgArea">
                              <span class="img"><img :src="product.product.thumbnail" :alt="product.product.displayName" /></span>
                            </div>
                            <div class="infoArea">
                              <div class="tit row2">
                                <span v-text="product.product.productName"></span>
                              </div>
                              <div class="txtItem">
                                <span v-text="product.product.model"></span>
                              </div>
                            </div>
                            <div class="btnGroup">
                              <button type="button" class="btn_s s" @click="deletePrduct">삭제</button>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <span class="label">
                    내용
                    <span class="required"><span class="blind">필수</span></span>
                  </span>
                  <textarea class="ipt" title="내용 입력" placeholder="내용입력(최소 20자)" v-model="contents"></textarea>

                  <div class="btnArea" v-if="imgList.length < 2">
                    <button type="button" class="btn_s addPic" @click="clickImgAdd">
                      <span class="ico"><img src="@/../static/img/mw/common/ico_picture.png" /></span>
                      사진 첨부하기
                    </button>
                    <input type="file" id="file" style="display: none;" accept="image/*" @change="selectImg($event)" />
                  </div>

                  <ul class="thumList div_2 al">
                    <li v-for="(img, imgIndex) in imgList" :key="imgIndex">
                      <div class="block" v-if="img != null">
                        <img
                          v-if="img.fileTpMCntn != null && img.fileTpMCntn != 'undefined'"
                          :src="`data:image/${img.fileTpMCntn === 'jpg' ? 'jpeg' : img.fileTpMCntn};base64,${img.file}`"
                          style="width: 100%; height: 100%;"
                          name="qnaFile"
                        />
                        <img v-else :src="img" style="width: 100%; height: 100%;" name="qnaFile" />
                        <button type="button" class="delBtn" @click="deleteImg(imgIndex)">
                          <span class="blind">선택된 사진 삭제</span>
                        </button>
                      </div>
                    </li>
                  </ul>

                  <ul class="txtList_star txtXS mt15">
                    <li>사진은 최대 2장까지 업로드 가능합니다.</li>
                    <li>파일 용량은 20MB 이하로 업로드 가능합니다.</li>
                  </ul>

                  <span class="label">휴대폰번호</span>
                  <input
                    type="tel"
                    id="phone_2"
                    class="ipt"
                    title="휴대폰 번호 입력"
                    placeholder="' - ' 없이 입력해주세요."
                    value=""
                    v-model="cellNum"
                  />
                  <!-- <p class="txt">휴대폰번호 입력시 답변 알림을 드립니다.</p> -->
                </div>
              </section>
              <!-- 본문 (e) -->
            </div>
          </div>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="insertQna" :disabled="regButtonShow">등록</button>
          </div>

          <button type="button" class="btnIco_close" @click="$emit('close')"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>
    <AllProductSearchPop v-if="allProductSearchPop" @close="allProductSearchPop = false" @selectItem="selectProduct"></AllProductSearchPop>
    <MyOrderListPop v-if="myOrderListPop" @close="myOrderListPop = false" @selectItem="selectProduct"></MyOrderListPop>
    <MessagePop v-if="messagePop" @close="messagePop = false">
      <p v-html="msg"></p>
    </MessagePop>
    <MessagePop v-if="messagePop2" @close="closePop">
      <p v-html="msg"></p>
    </MessagePop>
    <ProgressBar ref="progress"></ProgressBar>
  </div>
</template>

<script>
import AllProductSearchPop from '@/views/app/mypage/qna/AllProductSearchPop';
import MyOrderListPop from '@/views/app/mypage/qna/MyOrderListPop';
import ApiService from '@/common/api.service';
import MessagePop from '@/components/popup/MessagePop';
import { INPUT_QNA_TYPE, MAX_FILE_SIZE_CHECK } from '@/store/message.type.js';
import { isEmpty } from '@/common/common.function';
import ProgressBar from '@/views/app/comm/ProgressBar';

export default {
  name: 'MyQnaInsertPop',
  components: {
    AllProductSearchPop,
    MyOrderListPop,
    MessagePop,
    ProgressBar,
  },
  props: ['qnaId', 'imgList'],
  data() {
    return {
      allProductSearchPop: null,
      myOrderListPop: null,

      mainCodeList: [],
      subCodeList: [],

      mainCode: '',
      subCode: '',

      product: null,
      files: [], // 실제 업로드될 파일 리스트
      //imgList: [], // 화면에 노출될 이미지 url 리스트

      contents: null,
      cellNum: null,
      msg: null,
      messagePop: null,
      messagePop2: null,

      regButtonShow: true,
      fileAuth: String,
      interval: null,
      first: Boolean,

      fileMngId: null,
    };
  },
  watch: {
    mainCode() {
      this.checkInput();
    },
    subCode() {
      this.checkInput();
    },
    contents() {
      this.checkInput();
    },
    product() {
      this.checkInput();
    },
    fileAuth() {
      if (this.fileAuth == 'false') {
        this.msg = `아이폰 설정 → welrixrental 앱 → <br/>사진, 카메라 권한을 허용해주세요.`;
        this.messagePop = true;
      }
    },
  },
  mounted() {
    this.imgList.forEach(element => {
      const imgData = atob(element.file);
      const len = imgData.length;
      const array = new Array(len);

      for (let i = 0; i < len; i++) {
        array[i] = imgData.charCodeAt(i) & 0xff; // 비트 마스킹을 통해 msb를 보호한다.
      }

      const byteArray = new Uint8Array(array);
      let blob = new Blob([byteArray], { type: `image/${element.fileTpMCntn === 'jpg' ? 'jpeg' : element.fileTpMCntn}` });
      let file = new File([blob], element.exstFileLNm, { type: `image/${element.fileTpMCntn === 'jpg' ? 'jpeg' : element.fileTpMCntn}` });
      this.files.push(file);
    });

    // 대분류 조회
    ApiService.service('GET', '/common/code/QNT1')
      .then(({ data }) => {
        if (data.isSucceed) {
          this.mainCodeList = data.result[0].codeList;
        }
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });

    // qnaId 가 있을 시 상세 조회
    if (this.qnaId) {
      ApiService.service('GET', '/user/auth/qna/' + this.qnaId)
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            this.mainCode = data.result.mainType;
            this.selectMainCode();
            this.subCode = data.result.subType;
            this.contents = data.result.contents;
            this.cellNum = data.result.cellNum;
            this.fileMngId = data.result.fileMngId;
            //this.imgList = data.result.photos;

            // 상품 상세 조회
            if (data.result.prodCode != '') {
              ApiService.service('GET', '/product/code/' + data.result.prodCode)
                .then(({ data }) => {
                  if (data.isSucceed) {
                    this.product = data.result;
                  }
                })
                .catch(({ response }) => {
                  console.log('error : ' + response);
                });
            }
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    }
  },
  methods: {
    openSearchPop() {
      this.allProductSearchPop = true;
    },
    openOrderPop() {
      this.myOrderListPop = true;
    },
    selectMainCode() {
      if (this.mainCode === '') {
        this.subCode = '';
        this.subCodeList = [];
        return false;
      }

      this.subCode = '';
      ApiService.service('GET', '/common/subcode/' + this.mainCode)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.subCodeList = data.result;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    selectProduct(product) {
      this.product = product;
      this.myOrderListPop = false;
      this.allProductSearchPop = false;
    },
    deletePrduct() {
      this.product = null;
    },
    clickImgAdd() {
      // AsInfo, MyQnaInsertPop, MyReviewInsertPop
      document.getElementById('file').click();
      // if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      //   this.fileAuth = '';
      //   window.getIosFileAuth();
      //   setTimeout(() => {
      //     this.fileAuth = window.getFileAuthCheckValue();
      //   }, 100);
      // } else {
      //   document.getElementById('file').click();
      // }
    },
    selectImg(event) {
      console.log('event] ', event)
      let file = event.target.files[0];
      this.files.push(file);
      this.imgList.push(URL.createObjectURL(file));
      console.log(this.files);
      console.log(this.imgList);
    },
    deleteImg(index) {
      this.files.splice(index, 1);
      this.imgList.splice(index, 1);
      console.log(this.files);
      console.log(this.imgList);
    },
    insertQna() {
      if (isEmpty(this.mainCode) || isEmpty(this.subCode)) {
        this.msg = INPUT_QNA_TYPE;
        this.messagePop = true;
        return false;
      }

      if (this.mainCode == 'QNT10005' && isEmpty(this.product)) {
        // 상품문의시 상품선택 필수
        this.msg = '문의하실 상품을 선택해주세요.';
        this.messagePop = true;
        return false;
      }

      if (isEmpty(this.contents)) {
        this.msg = '내용을 입력해 주세요.';
        this.messagePop = true;
        return false;
      }

      if (this.contents.length < 20) {
        this.msg = '내용은 최소 20자 이상이여야 합니다.';
        this.messagePop = true;
        return false;
      }

      let maxFileSize = 10 * 1024 * 1024;
      let fileSize = 0;
      for (let file of this.files) {
        if (file != null) fileSize += file.size;
      }

      if (maxFileSize < fileSize) {
        this.msg = MAX_FILE_SIZE_CHECK;
        this.messagePop = true;
        return false;
      }

      let paramObj = new Object();
      let request = new Object();

      request.mainType = this.mainCode;
      request.subType = this.subCode;

      if (!isEmpty(this.product)) {
        request.productCode = this.product.product.productCode;
        request.orderId = this.product.orderId;
      }

      request.contents = this.contents;
      request.cellNum = this.cellNum;
      request.qnaId = this.qnaId;
      request.fileMngId = this.fileMngId;

      /*
      let imgList = [];
      const qnaFiles = document.getElementsByName('qnaFile');
      for (let i = 0; i < qnaFiles.length; i++) {
        imgList.push(qnaFiles[i].src);
      }
      request.imgList = imgList;
      */

      paramObj.request = request;
      paramObj.serviceType = 'app';

      let contentType = new Object();
      contentType.headers = { 'Content-Type': 'multipart/form-data' };

      let formData = new FormData();
      for (let file of this.files) {
        formData.append('files', file);
      }
      formData.append('param', JSON.stringify(paramObj));

      let url = '';
      if (!this.qnaId) {
        url = '/user/auth/qna';
        this.msg = '1:1 문의가 완료되었습니다.';
      } else {
        url = '/user/auth/qna/modify';
        this.msg = '1:1 문의 수정이 완료되었습니다.';
      }

      // for (let value of formData.values()) {
      //   console.log(value);
      // }
      this.$refs.progress.loadingStart();
      ApiService.service('POST', url, formData, contentType)
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            this.messagePop2 = true;
          }
        })
        .catch(({ response }) => {
          this.msg = `1:1 문의 수정에 실패하였습니다.<br/>잠시 후 다시 시도해주세요.`;
          this.messagePop2 = true;
          console.log('error : ' + response);
        })
        .finally(() => {
          this.$refs.progress.loadingEnd();
        });
    },
    closePop() {
      this.messagePop2 = false;
      this.$emit('close');
    },
    checkInput() {
      if (!isEmpty(this.mainCode) && !isEmpty(this.subCode) && !isEmpty(this.contents)) {
        if (this.mainCode == 'QNT10005' && isEmpty(this.product)) {
          this.regButtonShow = true;
        } else {
          this.regButtonShow = false;
        }
      } else {
        this.regButtonShow = true;
      }
    },
  },
};
</script>
